/* Force "View full details" to render as a full-width button (desktop + mobile)
   + Quick View landscape height fix for iOS Safari */
(function () {
  const SEL = 'a.quick-view__view-product-details-link, a.quick-view__view-product-detail-link';

  /* -------------------------
     1) Buttonify "View full details"
     ------------------------- */
  function buttonifyAll(root = document) {
    root.querySelectorAll(SEL).forEach(a => {
      if (a.dataset.buttonified) return;

      // Base button look (inline styles)
      a.classList.remove('btn--text-link');
      a.style.display = 'inline-flex';
      a.style.alignItems = 'center';
      a.style.justifyContent = 'center';
      a.style.width = '100%';
      a.style.minHeight = '46px';
      a.style.padding = '12px 16px';
      a.style.borderRadius = '8px';

      // Colors - match mobile (black bg, white text) and make them !important
      a.style.setProperty('background', 'var(--color-button, #111)', 'important');
      a.style.setProperty('background-color', 'var(--color-button, #111)', 'important');
      a.style.setProperty('color', 'var(--color-button-text, #fff)', 'important');
      a.style.setProperty('border', '0', 'important');

      // Typography and behavior
      a.style.fontWeight = '400';
      a.style.lineHeight = '1.2';
      a.style.textDecoration = 'none';
      a.style.setProperty('text-transform', 'none', 'important'); // change to 'uppercase' if you prefer
      a.style.pointerEvents = 'auto';
      a.style.cursor = 'pointer';
      a.style.transition = 'background-color .18s ease, border-color .18s ease, box-shadow .18s ease, color .18s ease';

      // Ensure the row lets the button span full width
      const row = a.closest('.product__ratings-and-link');
      if (row) { row.style.display = 'block'; row.style.gap = '0'; }

      // JS-driven hover/focus so it works even if CSS gets overridden
      a.addEventListener('mouseenter', () => {
        a.style.setProperty('background', '#2b2b2b', 'important');       // clearer contrast vs. #111
        a.style.setProperty('background-color', '#2b2b2b', 'important');
        a.style.setProperty('border', '0', 'important');
        a.style.setProperty('color', '#fff', 'important');
        a.style.setProperty('filter', 'brightness(1.05)', 'important');
        a.style.setProperty('box-shadow', '0 2px 12px rgba(0,0,0,.25)', 'important');
      });

      a.addEventListener('mouseleave', () => {
        a.style.setProperty('background', 'var(--color-button, #111)', 'important');
        a.style.setProperty('background-color', 'var(--color-button, #111)', 'important');
        a.style.setProperty('border', '0', 'important');
        a.style.setProperty('color', 'var(--color-button-text, #fff)', 'important');
        a.style.setProperty('filter', 'none', 'important');
        a.style.setProperty('box-shadow', 'none', 'important');
      });

      a.addEventListener('focus', () => {
        a.style.boxShadow = '0 0 0 3px rgba(0,0,0,.25)';
      });

      a.addEventListener('blur', () => {
        a.style.boxShadow = 'none';
      });

      a.dataset.buttonified = '1';
    });
  }

  /* -------------------------
     2) Landscape height fix (iOS Safari)
     - Use real innerHeight to size the modal and make inner content scrollable
     ------------------------- */
  const LANDSCAPE_Q = '(orientation: landscape) and (max-height: 480px)';

  function isPhoneLandscape() {
    return window.matchMedia ? window.matchMedia(LANDSCAPE_Q).matches : (window.innerHeight <= 480 && window.innerWidth > window.innerHeight);
  }

  function sizeModal(modal) {
    const h = window.innerHeight || document.documentElement.clientHeight;
    // Apply dynamic height via inline styles (wins against theme CSS)
    modal.style.setProperty('--qvvh', h + 'px');
    modal.style.setProperty('top', '0', 'important');
    modal.style.setProperty('bottom', '0', 'important');
    modal.style.setProperty('transform', 'none', 'important');
    modal.style.setProperty('height', 'var(--qvvh)', 'important');
    modal.style.setProperty('max-height', 'var(--qvvh)', 'important');

    const scroller = modal.querySelector('.modal__content, .drawer__content, .quick-product');
    if (scroller) {
      scroller.style.setProperty('max-height', 'calc(var(--qvvh) - 24px)', 'important');
      scroller.style.setProperty('overflow-y', 'auto', 'important');
      scroller.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      scroller.style.setProperty('overscroll-behavior', 'contain', 'important');
      scroller.style.setProperty('padding-bottom', 'env(safe-area-inset-bottom)', 'important');
    }
  }

  function applyLandscapeFix(root = document) {
    if (!isPhoneLandscape()) return;
    root.querySelectorAll('.quick-product-modal, .quick-view').forEach(sizeModal);
  }

  /* -------------------------
     Init + observers
     ------------------------- */
  // First run
  buttonifyAll();
  applyLandscapeFix();

  // MutationObserver: process newly injected Quick Views
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.(SEL) || n.querySelector?.(SEL)) buttonifyAll(n);
        if (n.matches?.('.quick-product-modal, .quick-view, [data-quick-product-modal]') || n.querySelector?.('.quick-product-modal, .quick-view, [data-quick-product-modal]')) {
          buttonifyAll(n);
          applyLandscapeFix(n);
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Resize/orientationchange: recalc landscape height
  window.addEventListener('resize', () => applyLandscapeFix());
  window.addEventListener('orientationchange', () => setTimeout(applyLandscapeFix, 100));

  // Fallback poller: some themes patch the DOM without triggering mutations
  setInterval(() => { buttonifyAll(); applyLandscapeFix(); }, 500);
})();